<template>
  <VanPopup
    v-model:show="modalStore.showCrystalNotEnoughModal"
    class="w-[300px]"
    closeable
    position="center"
    round
    teleport="body"
  >
    <div
      class="flex flex-col justify-center items-center gap-4 py-5 px-4 text-center"
    >
      <div class="flex items-center gap-1 text-base font-bold">
        <span>{{ $t(`purchase.miss.name`) }}</span>
        <img :src="useCrystalUrl()" alt="" class="w-[16px] girl" />
        <span>{{ fixNumber(missCrystalAmount) }}</span>
      </div>
      <div class="text-sm">
        <span> {{ $t(`purchase.miss.crystal`, { amount: price }) }}</span>
        <img
          :src="useCrystalUrl()"
          alt=""
          class="w-[16px] inline-block mt-[-2px] mx-[2px]"
        />
        <span>{{ quantity }}</span>
      </div>

      <div class="flex">
        <button class="btn btn-outline" @click="clickBuyMore">
          <!-- {{ t(`purchase.miss.other`) }} -->
          去充值
        </button>
        <!-- <button
          class="btn btn-primary"
          @click="userStore.clickPayItem({ id: packageId, quantity }, 0)"
        >
          <span>¥{{ price }}</span>
        </button> -->
      </div>
    </div>
  </VanPopup>
</template>
<script lang="ts" setup>
import { ApiGetCrystalPackage } from "@/apis/crystal";
import { fixNumber } from "@/components/Mission/MissionStat";
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import { StorageGet, StorageSet } from "@/tools/localStorage";
import { useCrystalUrl } from "@/use/common";
import { computed, ref } from "vue";
import { watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const userStore = useGlobalUser();
const router = useRouter();

const { t } = useI18n();
const packageId = ref(1);
const quantity = ref(5);
const price = ref(4.99);
const modalStore = useGlobalModal();

const missCrystalAmount = computed(() => {
  return modalStore.spentCrystalAmount - userStore.user.crystalQuantity;
});

watch(
  () => missCrystalAmount.value,
  (val) => {
    if (val <= 0) {
      modalStore.showCrystalNotEnoughModal = false;
    }
  }
);

watch(
  () => modalStore.showCrystalNotEnoughModal,
  async (val) => {
    if (val) {
      let purchaseList: { quantity: number; price: number; id: number }[] =
        StorageGet("purchaseList") || [];
      if (purchaseList.length === 0) {
        const { itemzz } = await ApiGetCrystalPackage();
        purchaseList = itemzz;
        StorageSet("purchaseList", purchaseList);
      }
      for (let i = 0; i < purchaseList.length; i++) {
        const { quantity: _quantity, price: _price, id } = purchaseList[i];
        if (
          modalStore.spentCrystalAmount <= _quantity ||
          i === purchaseList.length - 1
        ) {
          packageId.value = id;
          quantity.value = _quantity;
          price.value = _price;
          break;
        }
      }
    }
  }
);

const clickBuyMore = () => {
  router.push(`/crystal#1`);
  modalStore.showCrystalNotEnoughModal = false;
};
</script>
